import { useMutation } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

interface RevertAgentData {
  uuid: string;
  revision: number;
}

interface RevertAgentResponse {
  data: any;
}

export function useRevertAgent() {
  const { keycloak } = useKeycloak();

  return useMutation({
    mutationFn: async ({
      uuid,
      revision,
    }: RevertAgentData): Promise<RevertAgentResponse> => {
      const response = await fetch(
        `${
          import.meta.env.VITE_IMPORT_ENGINE_ENDPOINT
        }/api/v1/bundles/generate_bundle/functions/revert_to_agent_revision`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${keycloak.token}`,
          },
          method: 'POST',
          body: JSON.stringify({ uuid, revision }),
        }
      );

      const data = await response.json();

      return {
        data: data?.data,
      };
    },
  });
}
